import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const mintingTransactionService = createApi({
    reducerPath: 'mintingTransactionService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['MintingTransaction'],
    endpoints: (builder) => ({
        getAllMintingTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.mintingTransactionController.search}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        saveMintingTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.mintingTransactionController.save}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateMintingTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.mintingTransactionController.update}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteMintingTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.mintingTransactionController.delete}/${body.id}${body.type ? `?type=${body.type}` : ""}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getMintingTransactionById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.mintingTransactionController.getById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkUploadMintingTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.mintingTransactionController.uploadBulk}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        findAllMintingTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.mintingTransactionController.findAll}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
    })
});

export const {
    useGetAllMintingTransactionMutation,
    useSaveMintingTransactionMutation,
    useUpdateMintingTransactionMutation,
    useDeleteMintingTransactionMutation,
    useGetMintingTransactionByIdMutation,
    useBulkUploadMintingTransactionMutation,
    useFindAllMintingTransactionMutation,
} = mintingTransactionService;
